import { PickerOption } from '@sdk/components/forms/types';

export const matchColumns = ({
  columnOptions,
  firstRow,
  columnMap,
  rowSelectionMap,
}: {
  columnOptions: PickerOption[];
  firstRow: string[];
  columnMap: Record<number, string>;
  rowSelectionMap: Record<number, boolean>;
}) => {
  const updatedColumnMap = { ...columnMap };
  const updatedRowSelectionMap = { ...rowSelectionMap };

  const labelToValueDict = columnOptions.reduce((dict, option) => {
    dict[option.label] = option.value;
    return dict;
  }, {});

  firstRow.forEach((label, index) => {
    if (label in labelToValueDict) {
      updatedRowSelectionMap[0] = false;
    }

    updatedColumnMap[index] = labelToValueDict[label];
  });

  return [updatedColumnMap, updatedRowSelectionMap];
};
